import { Collection } from '../../shared/constants';
import { addDoc, deleteDoc, getAllDocs, updateDoc } from './collectionBaseWorker';

export const getAllApplications = async () => {
    return await getAllDocs({ collection: Collection.APPLICATION })
}

export const addApplication = async ({ data }) => {
    const doc = await addDoc({ collection: Collection.APPLICATION, data: data })
    return doc.id;
}

export const updateApplicationById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.APPLICATION, id: id, data: data })
}

export const deleteApplicationById = async ({ id }) => {
    await deleteDoc({ collection: Collection.APPLICATION, id: id })
}
